import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  AfterViewInit,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[fontResize]'
})
export class FontResizeDirective implements AfterViewInit, OnDestroy {
  @Input() text!: string; // kötelező input
  @Input() minFontSize = 12;
  @Input() maxFontSize = 40;
  @Input() maxWidth?: number;

  private observer: ResizeObserver;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.adjustFontSize();

    this.observer = new ResizeObserver(() => {
      this.adjustFontSize();
    });

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  private adjustFontSize(): void {
    const el = this.el.nativeElement as HTMLElement;

    // Ha van maxWidth, akkor a kisebbik értéket használjuk
    const containerWidth = el.clientWidth;
    const maxAllowedWidth = this.maxWidth
      ? Math.min(containerWidth, this.maxWidth)
      : containerWidth;

    const textLength = this.text.trim().length || 1;

    const fontWidth = (maxAllowedWidth / textLength);
    let fontSize = Math.floor(fontWidth / 0.6); // Kiszámoljuk a font szélességét a konténer szélessége és a szöveg hosszának arányából
    // Kiszámoljuk a fontméretet a szöveg hosszából és a konténer szélességéből

    if (fontSize < this.minFontSize) {
      fontSize = this.minFontSize;
    } else if (fontSize > this.maxFontSize) {
      fontSize = this.maxFontSize;
    }

    this.renderer.setStyle(el, 'font-size', `${fontSize}px`);
  }
}
